// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gpkojfs99XXxhK {
  margin: var(--ds-space-300, 24px);
  text-align: center;
}
.rrfvddlO21aZrx {
  max-height: 264px;
}
.rrfvddlO21aZrx.U7KFFDcs2T3Yej {
  overflow-y: scroll;
}
.SeWtiD01IWJ_0t {
  display: flex;
  flex-direction: column;
  min-height: 350px;
  max-height: 560px;
  background: var(--ds-surface, #ffffff);
}
.SeWtiD01IWJ_0t.FN2BqMuY1QtEj9 {
  height: auto;
}
.SeWtiD01IWJ_0t.M07SpKTiyNRX6H {
  justify-content: center;
}
@media only screen and (max-width: 750px) {
  .SeWtiD01IWJ_0t {
    flex-basis: auto;
    flex-grow: 1;
    flex-shrink: 1;
    min-height: 170px;
    margin-bottom: var(--ds-space-150, 12px);
  }
}
.LZm8v48gGsq2BH {
  height: 100%;
  margin-top: var(--ds-space-300, 24px);
  overflow-y: auto;
}
.SR_9Y7TicQ7sYx {
  margin-bottom: var(--ds-space-300, 24px);
}
.SR_9Y7TicQ7sYx:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
.KkBQd3921u8iQR {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  letter-spacing: -0.003em;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-0, 0);
}
.Msb2b1C_56m7pA {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.DTZzwdX_kZaOmN {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.UkkNkES94aCMDy {
  margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-300, 24px) var(--ds-space-150, 12px);
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
`, ""]);
// Exports
export var title = `gpkojfs99XXxhK`;
export var workspaceList = `rrfvddlO21aZrx`;
export var scroll = `U7KFFDcs2T3Yej`;
export var listBoxContainer = `SeWtiD01IWJ_0t`;
export var responsive = `FN2BqMuY1QtEj9`;
export var empty = `M07SpKTiyNRX6H`;
export var workspacesContainer = `LZm8v48gGsq2BH`;
export var workspacesGroup = `SR_9Y7TicQ7sYx`;
export var groupHeader = `KkBQd3921u8iQR`;
export var spinnerContainer = `Msb2b1C_56m7pA`;
export var noWorkspaceContainer = `DTZzwdX_kZaOmN`;
export var noWorkspaceText = `UkkNkES94aCMDy`;
export default ___CSS_LOADER_EXPORT___;
